export default function extractKeys(obj) {
  const keys = Object.keys(obj)
  const nestedKeys = Object.values(obj)
    .filter((val) => val && typeof val === 'object')
    .flatMap((nested) => Object.keys(nested))
  return [...keys, ...nestedKeys]
}
